import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& > div:nth-child(1)': {
      width: '100% !important',
      '& figure': {
        '& div:nth-child(2)': {
          width: '100% !important',
        },
      },
    },
  },
  label: {
    transform: 'scale(0.75)',
  },
  field: {
    marginBottom: theme.spacing(2),
  },
  grid: {
    padding: theme.spacing(2),
    width: '100%',
  },
}));
